<template>
  <div :data-depth="depth">
    <div v-for="(evaluateItem, index) in listItems" :key="index" class="flow-step-item-section">
      <FlowStepListItem
        v-if="evaluateItem.type === 'logic-transition'"
        :id="evaluateItem.id"
        :icon="getIcon(evaluateItem)"
        :icon-class="getIconColor(evaluateItem)"
        :invalid="getTransitionText(evaluateItem.payload, steps, flows) === 'Invalid Step!'"
      >
        <span v-html="transitionText(evaluateItem)"></span>
      </FlowStepListItem>
      <template v-else-if="evaluateItem.type === 'logic-condition'">
        <FlowStepListItem v-if="depth < 3" content-class="w-full" :icon="getIcon(evaluateItem)" :icon-class="getIconColor(evaluateItem)">
          <div v-for="(expression, i) in evaluateItem.payload.expressions" :key="expression.id">
            <span class="font-700">{{ getExpressionLabel(i, evaluateItem.payload.expressions.length + 1) }}</span>
            <StepBlocks :depth="depth + 1" :steps="steps" :step="step" :list-items="expression.payload" />
          </div>
          <span class="font-700">{{ getExpressionLabel(1, 2) }}</span>

          <StepBlocks :depth="depth + 1" :steps="steps" :step="step" :list-items="evaluateItem.payload.else" />
        </FlowStepListItem>
      </template>
      <template v-else-if="evaluateItem.type === 'logic-parallel'">
        <FlowStepListItem v-if="depth < 2" content-class="w-full" :icon="getIcon(evaluateItem)" :icon-class="getIconColor(evaluateItem)">
          <span class="font-700">{{ $t(`evaluate_editor.${evaluateItem.type}`) }}</span>
          <div v-for="item in evaluateItem.payload" :key="item.id">
            <FlowStepListItem :id="item.id" :icon="getIcon(item)" :icon-class="getIconColor(item)" style="background-color: white !important">
              <span>{{ $t(`evaluate_editor.${item.type}`) }}</span>
            </FlowStepListItem>
          </div>
        </FlowStepListItem>
      </template>
      <template v-else-if="evaluateItem.type === 'ai-agent'">
        <FlowStepListItem v-if="depth < 2" content-class="w-full" :icon="getIcon(evaluateItem)" :icon-class="getIconColor(evaluateItem)">
          <span class="font-700">{{ $t(`evaluate_editor.${evaluateItem.type}`) }}</span>
          <div v-for="item in evaluateItem.payload.tools" :key="item.id">
            <FlowStepListItem :id="item.id" :icon="getIcon(item)" :icon-class="getIconColor(item)" style="background-color: white !important">
              <span>{{ $t(`evaluate_editor.${item.type}`) }}</span>
            </FlowStepListItem>
          </div>
        </FlowStepListItem>
      </template>
      <template v-else>
        <FlowStepListItem :id="evaluateItem.id" :icon="getIcon(evaluateItem)" :icon-class="getIconColor(evaluateItem)">
          <span>{{ $t(`evaluate_editor.${evaluateItem.type}`) }}</span>
        </FlowStepListItem>
      </template>
    </div>
  </div>
</template>

<script>
// Designer-specific copy of FlowStepList. The ONLY behavioural difference is that
// a logic-transition row is given a DOM id of the block's own (unique) `id`
// rather than `payload.id` — saved flows can share a `payload.id` across multiple
// transition blocks, which would otherwise collide for handles/edges/measurement.
import { mapState, mapGetters } from 'vuex';
import FlowStepListItem from '@/components/flow/FlowStepListItem';
import { getTransitionText, TRANSITION_ICONS, getExpressionLabel } from '@/helpers/flow';
import EvaluateItems, { Categories } from '@/components/flow/evaluate/EvaluateItems';

export default {
  name: 'StepBlocks',
  props: {
    listItems: { type: Array },
    steps: { type: Array },
    step: { type: Object },
    depth: { type: Number, default: 1 },
  },
  components: { FlowStepListItem },
  data() {
    return { TRANSITION_ICONS };
  },
  computed: {
    ...mapState(['selectedIntentDefinition']),
    ...mapGetters(['getProjectFlows']),
    flows() {
      return Object.keys(this.getProjectFlows()).map((key) => ({ label: this.getProjectFlows()[key].name, value: key }));
    },
  },
  methods: {
    getIcon(evaluateItem) {
      if (evaluateItem.type === 'logic-transition') {
        return TRANSITION_ICONS[evaluateItem.payload.type];
      }
      return EvaluateItems?.[evaluateItem.type]?.icon || '';
    },
    getIconColor(evaluateItem) {
      return Categories.find((cat) => cat.key === EvaluateItems?.[evaluateItem.type]?.category)?.color || '';
    },
    getExpressionLabel,
    getTransitionText,
    transitionText(evaluateItem) {
      if (evaluateItem?.payload?.type === 'step' || evaluateItem?.payload?.type === 'agent') {
        return getTransitionText(evaluateItem.payload, this.steps, this.flows);
      }
      return `${this.$t('evaluate_editor.logic-transition')}: ${getTransitionText(evaluateItem.payload, this.steps)}`;
    },
  },
};
</script>
